import { Platform } from 'react-native';

export const RATE_APP_IOS_URL = process.env.EXPO_PUBLIC_RATE_APP_IOS_URL;
export const RATE_APP_ANDROID_URL =
  process.env.EXPO_PUBLIC_RATE_APP_ANDROID_URL;

/** Store listing of the current platform; undefined on web. */
export const RATE_APP_URL: string | undefined = Platform.select({
  ios: RATE_APP_IOS_URL,
  android: RATE_APP_ANDROID_URL,
  default: undefined
});
